import React, { useEffect } from "react";

const SIGNATURE_WIDTH = 600;
const IVORY = "#f0ebe2";
const BLUE = "#152a38";
const BUTTER = "#fef4c4";
const DISCLAIMER =
  "Les informations relatives aux instruments financiers mentionnés dans le présent e-mail ne constituent qu'une présentation succincte des caractéristiques de ces produits et vous sont communiquées à titre d’information comme simple support de discussion. Avant toute décision d'investissement, il appartiendra à chaque investisseur de prendre connaissance de l'ensemble des caractéristiques des instruments financiers et de procéder à une évaluation des risques avantages et inconvénients liés à un tel investissement";

const tableReset = /** @type {const} */ ({
  border: "0",
  borderCollapse: "collapse",
  borderSpacing: "0",
  msoTableLspace: "0pt",
  msoTableRspace: "0pt",
});

const cellReset = /** @type {const} */ ({
  border: "0",
  msoLineHeightRule: "exactly",
});

const getAssetUrl = fileName => {
  return `https://files.myclientisrich.com/cr-concept/${fileName}`;
};

const normalizePhoneHref = phone => phone.replace(/[^\d+]/g, "");

const SignatureFormatter = ({ user }) => {
  useEffect(() => {
    document.title = "CR Concept Patrimoine | Signature";
  }, []);

  const fullName = `${user.firstname} ${user.lastname}`.trim();

  return (
    <div className="wrapper-table">
      <table
        align="left"
        border="0"
        cellPadding="0"
        cellSpacing="0"
        role="presentation"
        style={{
          ...tableReset,
          backgroundColor: IVORY,
          color: BLUE,
          fontFamily: "Arial, Helvetica, sans-serif",
          margin: "0",
          textAlign: "left",
          tableLayout: "fixed",
          width: `${SIGNATURE_WIDTH}px`,
        }}
        width={SIGNATURE_WIDTH}
      >
        <tbody>
          <tr>
            <td
              height="201"
              style={{
                ...cellReset,
                backgroundColor: IVORY,
                height: "201px",
                padding: "0",
              }}
              valign="middle"
              width={SIGNATURE_WIDTH}
            >
              <table
                border="0"
                cellPadding="0"
                cellSpacing="0"
                role="presentation"
                style={{ ...tableReset, width: `${SIGNATURE_WIDTH}px` }}
                width={SIGNATURE_WIDTH}
              >
                <tbody>
                  <tr>
                    <td style={{ ...cellReset, fontSize: "0", lineHeight: "0" }} width="22">
                      &nbsp;
                    </td>

                    <td style={{ ...cellReset, padding: "0" }} valign="middle" width="268">
                      <img
                        alt="CR Concept Patrimoine"
                        border="0"
                        height="64"
                        src={getAssetUrl("logo.svg")}
                        style={{
                          border: "0",
                          display: "block",
                          height: "64px",
                          width: "268px",
                        }}
                        width="268"
                      />
                    </td>

                    <td style={{ ...cellReset, fontSize: "0", lineHeight: "0" }} width="18">
                      &nbsp;
                    </td>

                    <td style={{ ...cellReset, padding: "0" }} valign="middle" width="1">
                      <img
                        alt=""
                        border="0"
                        height="149"
                        src={getAssetUrl("separator.png")}
                        style={{
                          border: "0",
                          display: "block",
                          height: "149px",
                          width: "1px",
                        }}
                        width="1"
                      />
                    </td>

                    <td style={{ ...cellReset, fontSize: "0", lineHeight: "0" }} width="18">
                      &nbsp;
                    </td>

                    <td style={{ ...cellReset, padding: "0" }} valign="middle" width="250">
                      <table
                        border="0"
                        cellPadding="0"
                        cellSpacing="0"
                        role="presentation"
                        style={tableReset}
                        width="250"
                      >
                        <tbody>
                          <tr>
                            <td style={{ ...cellReset, padding: "0 0 14px" }}>
                              <p
                                style={{
                                  color: BLUE,
                                  fontFamily: "Arial, Helvetica, sans-serif",
                                  fontSize: "28px",
                                  fontWeight: "700",
                                  lineHeight: "30px",
                                  margin: "0",
                                  msoLineHeightRule: "exactly",
                                }}
                              >
                                {fullName}
                              </p>
                              <p
                                style={{
                                  color: BLUE,
                                  fontFamily: "Arial, Helvetica, sans-serif",
                                  fontSize: "11px",
                                  fontWeight: "400",
                                  lineHeight: "12px",
                                  margin: "0",
                                  msoLineHeightRule: "exactly",
                                  textTransform: "uppercase",
                                }}
                              >
                                {user.job}
                              </p>
                            </td>
                          </tr>

                          <tr>
                            <td style={{ ...cellReset, padding: "0" }}>
                              <p
                                style={{
                                  color: BLUE,
                                  fontFamily: "Arial, Helvetica, sans-serif",
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  lineHeight: "15px",
                                  margin: "0 0 3px",
                                  msoLineHeightRule: "exactly",
                                }}
                              >
                                <a
                                  href={`tel:${normalizePhoneHref(user.phone)}`}
                                  style={{ color: BLUE, textDecoration: "none" }}
                                >
                                  {user.phone}
                                </a>
                              </p>
                              <p
                                style={{
                                  color: BLUE,
                                  fontFamily: "Arial, Helvetica, sans-serif",
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  lineHeight: "15px",
                                  margin: "0 0 6px",
                                  msoLineHeightRule: "exactly",
                                }}
                              >
                                <a
                                  href="tel:+33388109445"
                                  style={{ color: BLUE, textDecoration: "none" }}
                                >
                                  +33 (0)3 88 10 94 45
                                </a>
                              </p>
                              <p
                                style={{
                                  color: BLUE,
                                  fontFamily: "Arial, Helvetica, sans-serif",
                                  fontSize: "13px",
                                  fontWeight: "400",
                                  lineHeight: "15px",
                                  margin: "0 0 6px",
                                  msoLineHeightRule: "exactly",
                                }}
                              >
                                <a
                                  href="mailto:c.roy@crconceptpatrimoine.com"
                                  style={{ color: BLUE, textDecoration: "none" }}
                                >
                                  c.roy@crconceptpatrimoine.com
                                </a>
                              </p>
                              <p
                                style={{
                                  color: BLUE,
                                  fontFamily: "Arial, Helvetica, sans-serif",
                                  fontSize: "13px",
                                  fontWeight: "400",
                                  lineHeight: "15px",
                                  margin: "0",
                                  msoLineHeightRule: "exactly",
                                }}
                              >
                                5B, rue Fischart, 67000 Strasbourg
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>

                    <td style={{ ...cellReset, fontSize: "0", lineHeight: "0" }} width="23">
                      &nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td
              bgcolor={BLUE}
              height="29"
              style={{
                ...cellReset,
                backgroundColor: BLUE,
                height: "29px",
                padding: "0",
                textAlign: "center",
              }}
              valign="middle"
              width={SIGNATURE_WIDTH}
            >
              <p
                style={{
                  color: BUTTER,
                  fontFamily: "Arial, Helvetica, sans-serif",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "29px",
                  margin: "0",
                  msoLineHeightRule: "exactly",
                }}
              >
                Permanence téléphonique : 8 h 30 – 12 h · N° ORIAS : 16004125 · N° SIRET : 82103936900037
              </p>
            </td>
          </tr>

          <tr>
            <td
              bgcolor={IVORY}
              style={{
                ...cellReset,
                backgroundColor: IVORY,
                padding: "14px 40px 17px",
                textAlign: "center",
              }}
              width={SIGNATURE_WIDTH}
            >
              <p
                style={{
                  color: BLUE,
                  fontFamily: "Arial, Helvetica, sans-serif",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "17px",
                  margin: "0",
                  msoLineHeightRule: "exactly",
                  opacity: "0.6",
                }}
              >
                {DISCLAIMER}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SignatureFormatter;
